// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qa5O","left":"styles_left__kQMM8"};